export { default } from './MobileStockCardSlider';
